import cx from 'classnames';
import {
    HOMEPAGE_HEADING,
    HOMEPAGE_PARA_1_CONTENT,
    HOMEPAGE_PARA_1_HEADING,
    HOMEPAGE_PARA_2_CONTENT,
    HOMEPAGE_PARA_2_HEADING,
    HOMEPAGE_PARA_3_CONTENT,
    HOMEPAGE_PARA_3_HEADING,
} from 'mk/autogenerated/translations/SignupLoginWrapper.0f963a8e53b62c70ca66a6befcf496d6'
import assetUrl from 'mk/common/assetUrl';
import { ACTIVE_SERVER_ID } from 'mk/settings';
import { homepageUrl } from 'mk2/apps/home/urls';
import { SignupLoginTabs } from 'mk2/apps/users/components/SignupLoginTabs';
import Img from 'mk2/components/Img';
import { FormPageType } from 'mk2/constants';
import InstallPrompt from 'mk2/containers/InstallPrompt/InstallPrompt';
import React from 'react';
import styles from './SignupLoginWrapper.mscss';

interface OwnProps {
    className?: string;
    qs: string;
    mobile: boolean;
    currentFormPage: FormPageType;
}

type Props = OwnProps;

export class SignupLoginWrapper extends React.Component<Props> {

    public render() {
        const { qs, children, className, mobile, currentFormPage } = this.props;
        return (
            <div className={cx(styles.SignupLoginWrapper, className)}>
                <div className={styles.SignupLoginWrapper__wrapper}>

                    <div className={styles.SignupLoginWrapper__form}>
                        {!mobile &&
                            <a className={styles.SignupLoginWrapper__logo} href={homepageUrl}>
                                <Img src={assetUrl + 'img/logos/ver-3/logo-201@2x.png'} width={160} height={36} />
                            </a>
                        }

                        {!mobile && currentFormPage === FormPageType.Main &&
                            <SignupLoginTabs qs={qs}/>
                        }

                        {children}

                        {!mobile &&
                            <Img
                                className={styles.SignupLoginWrapper__sticker}
                                src={assetUrl + 'img/photoblog/stickers/1.png'}
                                width={180}
                                height={180}
                            />
                        }
                    </div>

                    {!mobile ? (
                        <div className={styles.SignupLoginWrapper__content_wrapper}>
                            <div className={styles.SignupLoginWrapper__yt_video}>
                                {ACTIVE_SERVER_ID === 202
                                    ? <iframe
                                        width="600"
                                        height="338"
                                        frameBorder="0"
                                        allowFullScreen
                                        src="https://www.youtube.com/embed/cKkBe3TOg0I?rel=0"
                                    />
                                    : <Img src={assetUrl + 'img/homepage/variant-b/main-2.png'} width={600} height={338}/>
                                }
                            </div>

                            <div className={styles.SignupLoginWrapper__content}>
                                <h1>{HOMEPAGE_HEADING}</h1>

                                <div className={styles.SignupLoginWrapper__content_box}>
                                    <Img
                                        src={assetUrl + 'img/homepage/friends@2x.png'}
                                        width={80}
                                        height={80}
                                    />
                                    <div className={styles.SignupLoginWrapper__content_box__text}>
                                        <h2>{HOMEPAGE_PARA_1_HEADING}</h2>
                                        <p>{HOMEPAGE_PARA_1_CONTENT}</p>
                                    </div>
                                </div>

                                <div className={styles.SignupLoginWrapper__content_box}>
                                    <Img
                                        src={assetUrl + 'img/homepage/messaging@2x.png'}
                                        width={80}
                                        height={80}
                                    />
                                    <div className={styles.SignupLoginWrapper__content_box__text}>
                                        <h2>{HOMEPAGE_PARA_2_HEADING}</h2>
                                        <p>{HOMEPAGE_PARA_2_CONTENT}</p>
                                    </div>
                                </div>

                                <div className={styles.SignupLoginWrapper__content_box}>
                                    <Img
                                        src={assetUrl + 'img/homepage/stroller@2x.png'}
                                        width={80}
                                        height={80}
                                    />
                                    <div className={styles.SignupLoginWrapper__content_box__text}>
                                        <h2>{HOMEPAGE_PARA_3_HEADING}</h2>
                                        <p>{HOMEPAGE_PARA_3_CONTENT}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <InstallPrompt />
                    )}
                </div>
            </div>
        );
    }
}
